module.exports = __webpack_public_path__ + "img/symbol_7.4d678997.png";